import { render, staticRenderFns } from "./lateArrivalPenalty.vue?vue&type=template&id=c8dd68d2&scoped=true&"
import script from "./lateArrivalPenalty.vue?vue&type=script&lang=js&"
export * from "./lateArrivalPenalty.vue?vue&type=script&lang=js&"
import style0 from "./lateArrivalPenalty.vue?vue&type=style&index=0&id=c8dd68d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dd68d2",
  null
  
)

export default component.exports